var _desc, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigurePumpSizing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 280",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Pump transfer system") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "Two vessels connected by suction and discharge pipes with a pump between them.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#001e1d",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 62v112c0 22 18 40 40 40h49c22 0 40-18 40-40V62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 30v144c0 22 18 40 40 40h49c22 0 40-18 40-40V30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 94h127M356 65h127",
    stroke: "#86ceb2",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 214v24h94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 238h96v-24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 238,
    r: 42,
    fill: "#86ceb2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 238h44M260 216v44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 238h23M302 238h23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 226l12 12-12 12M314 226l12 12-12 12",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 94v119M336 65v148",
    strokeWidth: 3,
    strokeDasharray: "8 8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#001e1d",
    fontFamily: "Arial, sans-serif",
    fontSize: 18
  }, /*#__PURE__*/React.createElement("text", {
    x: 69,
    y: 50
  }, "Vessel 1"), /*#__PURE__*/React.createElement("text", {
    x: 387,
    y: 23
  }, "Vessel 2"), /*#__PURE__*/React.createElement("text", {
    x: 236,
    y: 246,
    fontWeight: 700
  }, "P"), /*#__PURE__*/React.createElement("text", {
    x: 173,
    y: 86
  }, "z\u2081"), /*#__PURE__*/React.createElement("text", {
    x: 325,
    y: 56
  }, "z\u2082"), /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 266
  }, "Suction"), /*#__PURE__*/React.createElement("text", {
    x: 332,
    y: 266
  }, "Discharge"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigurePumpSizing);
export default __webpack_public_path__ + "static/media/calc-figure-pump-sizing.c213fa0e1a56d5f094b06c3964d90119.svg";
export { ForwardRef as ReactComponent };